import { clearProfileImage } from '../store/settings/settingsSlice';
import { logout } from '../store/auth/authSlice';


export const handleLogout = async (dispatch, navigate) => {
    try {
      // First clear auth states
      await dispatch(logout());
      await dispatch(clearProfileImage());
      
      // Clear all storage
      localStorage.clear();
      sessionStorage.clear();
  
      // Force a small delay to ensure state updates are processed
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // Use replace and add a callback to reload after navigation
      navigate('/', { replace: true }, () => {
        window.location.reload();
      });
  
    } catch (error) {
      console.error('Logout failed:', error);
      // Fallback - force reload to clear state
      window.location.href = '/';
    }
  };